import { gql } from "@apollo/client";


export const signIn = gql`
    query signIn($email: String!, $password: String!){
        signIn(email:$email, password:$password){
            status_code
            message
            sessionToken
        }
    }
`;

export const verifyOtp = gql`
  query verifyOtp ($email: String!, $otp: String!) {
    verifyOtp (email: $email, otp: $otp) {
        status_code
        message
        token
    }
}
`;